module.exports = __webpack_public_path__ + "static/media/intro-splash.2b4e72f6.mp4";